// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"345":"portfolio","594":"about"}[chunkId] + "." + {"345":"afc22b36","594":"e05c05a2"}[chunkId] + ".js";
};